import React from 'react';

import styles from './QuestionConnectionLine.module.css';

export default function({ question, state }) {
  const content = state && state.survey && state.survey.content;
  const groups = (content && content.groups) || [];
  const questions = (state && state.survey && state.survey.questions) || {};

  if (!question || !groups.length) return null;

  const childGroup = groups.find(
    g => g.flows && g.flows.indexOf(question.id) > -1
  );
  if (!childGroup) return null;

  const parentGroup = groups.find(
    g => g.flows && g.flows.indexOf(childGroup.id) > -1
  );
  if (!parentGroup || !parentGroup.isGroupAndRandomise) return null;

  const totalQuestions = childGroup.flows.length;
  if (totalQuestions === 1) return null;

  const lockedFlags = childGroup.flows.map(
    flowId =>
      !!(questions[flowId] && questions[flowId].groupAndRandomiseLockedPosition)
  );
  const questionIndex = childGroup.flows.indexOf(question.id);
  const lockedPosition = lockedFlags[questionIndex];

  const hasPrev = lockedFlags.some((locked, i) => !locked && i < questionIndex);
  const hasNext = lockedFlags.some((locked, i) => !locked && i > questionIndex);

  // Without randomisation every question of the child group is connected
  if (!childGroup.randomized) {
    if (questionIndex === 0) {
      return (
        <div className={styles.container}>
          <div className={`${styles.topContainer} ${styles.bottomLine}`} />
          <div className={`${styles.bottomContainer} ${styles.leftLine}`} />
        </div>
      );
    }

    // Last
    if (questionIndex === totalQuestions - 1) {
      return (
        <div className={styles.container}>
          <div className={`${styles.topContainer} ${styles.leftLine}`} />
          <div className={`${styles.bottomContainer} ${styles.topLine}`} />
        </div>
      );
    }

    return (
      <div className={styles.container}>
        <div
          className={`${styles.topContainer} ${styles.leftLine}  ${
            styles.bottomLine
          }`}
        />
        <div className={`${styles.bottomContainer} ${styles.leftLine}`} />
      </div>
    );
  }

  if (!lockedPosition) {
    if (hasPrev && hasNext) {
      return (
        <div className={`${styles.container} fade-in`}>
          <div
            className={`${styles.topContainer}
              ${styles.leftLine} ${styles.bottomLine}`}
          />
          <div className={`${styles.bottomContainer} ${styles.leftLine}`} />
        </div>
      );
    }

    if (hasPrev) {
      return (
        <div className={`${styles.container} fade-in`}>
          <div
            className={`${styles.topContainer}
              ${styles.leftLine} ${styles.bottomLine}`}
          />
          <div className={`${styles.bottomContainer}`} />
        </div>
      );
    }

    if (hasNext) {
      return (
        <div className={`${styles.container} fade-in`}>
          <div className={`${styles.topContainer}`} />
          <div
            className={`${styles.bottomContainer} ${styles.topLine} ${
              styles.leftLine
            }`}
          />
        </div>
      );
    }
  }

  if (hasPrev && hasNext) {
    return (
      <div className={`${styles.container} fade-in`}>
        <div
          className={`${styles.topContainer}
            ${styles.leftLine}`}
        />
        <div className={`${styles.bottomContainer} ${styles.leftLine}`} />
      </div>
    );
  }

  return null;
}
